import { getReferralService } from '@http/getReferralService'
import { User } from '@types'
import { selectCredentials } from '@views/loginView/state/loginSlice'
import { call, takeEvery, put, select } from 'redux-saga/effects'
import { getReferrals, referralFailed, referralSuccess } from './referralSlice'

export function* referralHttp() {
  const { cocap } = yield select(selectCredentials)
  try {
    const referrals: User[] = yield call(getReferralService, cocap)
    yield put(referralSuccess(referrals))
  } catch (e) {
    yield put(referralFailed(e.message))
  }
}

export default function* referralSaga() {
  yield takeEvery(getReferrals.type, referralHttp)
}
